// extracted by mini-css-extract-plugin
module.exports = {"item":"FiltersItem_item__1smSX","icon":"FiltersItem_icon__3sx4o"};